import { MenuNavigation, MenuNavigationV2 } from '@models/navigationBar';
import { NavigationEntityAdminApiService } from './navigationEntityAdminApiService';

export class MenuNavigationAdminService<Version extends 1 | 2> extends NavigationEntityAdminApiService<
    Version extends 1 ? MenuNavigation : MenuNavigationV2
> {
    public constructor() {
        super('/api/admin/menu-navigation');
    }
}
